// import "./App.css";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Home from "./components/pages/Home";
// import Header from "./components/navbar/Header";
// import Contact from "./components/pages/Contact";
// import About from "./components/pages/About";
// import Works from "./components/pages/Works";
// import Projects from "./components/pages/Projects";
// import Team from "./components/about/Team";
// import Press from "./components/about/Press";
// import Philosophy from "./components/about/Philosophy";
// import Residential1 from "./components/works/Residantial1";
// import Gallery from "./components/pages/Gallery";
// import Productcategory from "./components/pages/Productcategory";
// import Productsubcategory from "./components/pages/Productsubcategory";
// import Productbysubcategory from "./components/pages/Productbysubcategory";
// import Productbydetail from "./components/pages/Productbydetail";
// import AuthForm from "./components/mainpages/AuthForm";
// import EcomCart from "./components/pages/Ecom/EcomCart";
// import Placeorder from "./components/pages/Ecom/Placeorder";
// import Myorders from "./components/pages/Ecom/Myorders";
// import AdminOrders from "./components/pages/Ecom/AdminOrders";
// import PrivacyPolicy from "./components/Policy/PrivacyPolicy";
// import TermsConditions from "./components/Policy/TermsConditions";
// import PaymentPolicy from "./components/Policy/PaymentPolicy";
// import OrderPolicy from "./components/Policy/OrderPolicy";
// import ReturnRefundPolicy from "./components/Policy/ReturnRefundPolicy";
// import Trackorder from "./components/pages/Ecom/Trackorder";
// // import "./App.css";
// import "./components/navbar/Header.css";

// function App() {
//   return (
//     <div>
//       <BrowserRouter>
//         <Header />

//         <Routes>
//           <Route path="/" element={<Home />}></Route>
//           <Route path="/contact" element={<Contact />}></Route>
//           <Route path="/about" element={<About />}></Route>
//           <Route path="/works" element={<Works />}></Route>
//           <Route path="/AuthForm" element={<AuthForm />} />
//           <Route path="/projects" element={<Projects />}></Route>
//           <Route path="/team" element={<Team />}></Route>
//           <Route path="/press" element={<Press />}></Route>
//           <Route path="/philosophy" element={<Philosophy />}></Route>

//           <Route path="/Residential1/:id" element={<Residential1 />} />
//           <Route path="/gallery" element={<Gallery />}></Route>
//           <Route path="/Productcategory" element={<Productcategory />}></Route>
//           <Route path="/cart" element={<EcomCart />}></Route>
//           <Route path="/track-order" element={<Trackorder />}></Route>
//           <Route path="/place-order" element={<Placeorder />}></Route>
//           <Route path="/myorders" element={<Myorders />} />
//           {/* <Route path="/myorders" element={<Myorders />} /> */}
//           <Route path="/admin-orders" element={<AdminOrders />} />
          
//           <Route
//             path="/productsubcategory/:categoryId"
//             element={<Productsubcategory />}
//           ></Route>
//           <Route
//             path="/Productbysubcategory/:subcategoryId"
//             element={<Productbysubcategory />}
//           ></Route>
//           {/* <Route
//             path="/Productbydetail/:productId"
//             element={<Productbydetail />}
//           ></Route> */}
//           <Route
//             path="/Productbydetail/:id"
//             element={<Productbydetail />}
//           ></Route>
//           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//           <Route path="/terms-conditions" element={<TermsConditions />} />
//           <Route path="/payment-policy" element={<PaymentPolicy />} />
//           <Route path="/order-policy" element={<OrderPolicy />} />
//           <Route
//             path="/return-refund-policy"
//             element={<ReturnRefundPolicy />}
//           />
//         </Routes>
//       </BrowserRouter>
//     </div>
//   );
// }

// export default App;


import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/pages/Home";
import Header from "./components/navbar/Header";
import Contact from "./components/pages/Contact";
import About from "./components/pages/About";
import Works from "./components/pages/Works";
import Projects from "./components/pages/Projects";
import Team from "./components/about/Team";
import Press from "./components/about/Press";
import Philosophy from "./components/about/Philosophy";
import Residential1 from "./components/works/Residantial1";
import Gallery from "./components/pages/Gallery";
import Productcategory from "./components/pages/Productcategory";
import Productsubcategory from "./components/pages/Productsubcategory";
import Productbysubcategory from "./components/pages/Productbysubcategory";
import Productbydetail from "./components/pages/Productbydetail";
import AuthForm from "./components/mainpages/AuthForm";
import EcomCart from "./components/pages/Ecom/EcomCart";
import Placeorder from "./components/pages/Ecom/Placeorder";
import Myorders from "./components/pages/Ecom/Myorders";
import AdminOrders from "./components/pages/Ecom/AdminOrders";
import PrivacyPolicy from "./components/Policy/PrivacyPolicy";
import TermsConditions from "./components/Policy/TermsConditions";
import PaymentPolicy from "./components/Policy/PaymentPolicy";
import OrderPolicy from "./components/Policy/OrderPolicy";
import ReturnRefundPolicy from "./components/Policy/ReturnRefundPolicy";
import Trackorder from "./components/pages/Ecom/Trackorder";
import ProjectDetail from "./components/pages/ProjectDetail";
import "./components/navbar/Header.css";
import SmoothFollower from "./components/SmoothFollower";

function App() {
  return (
    <div style={{ margin: 0, padding: 0 }}>
      <BrowserRouter>
        <SmoothFollower />
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          
          {/* Works Routes */}
          <Route path="/works" element={<Works />} />
          
          {/* Project Detail Routes */}
          <Route path="/project-detail/:id" element={<ProjectDetail />} />
          <Route path="/project-detail/category/:categoryId" element={<ProjectDetail />} />
          
          {/* Keep old route for backward compatibility */}
          <Route path="/Residential1/:id" element={<Residential1 />} />
          
          <Route path="/AuthForm" element={<AuthForm />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/team" element={<Team />} />
          <Route path="/press" element={<Press />} />
          <Route path="/philosophy" element={<Philosophy />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/Productcategory" element={<Productcategory />} />
          <Route path="/cart" element={<EcomCart />} />
          <Route path="/track-order" element={<Trackorder />} />
          <Route path="/place-order" element={<Placeorder />} />
          <Route path="/myorders" element={<Myorders />} />
          <Route path="/admin-orders" element={<AdminOrders />} />
          
          <Route
            path="/productsubcategory/:categoryId"
            element={<Productsubcategory />}
          />
          <Route
            path="/Productbysubcategory/:subcategoryId"
            element={<Productbysubcategory />}
          />
          <Route
            path="/Productbydetail/:id"
            element={<Productbydetail />}
          />
          
          {/* Policy Routes */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/payment-policy" element={<PaymentPolicy />} />
          <Route path="/order-policy" element={<OrderPolicy />} />
          <Route
            path="/return-refund-policy"
            element={<ReturnRefundPolicy />}
          />

        </Routes>
      </BrowserRouter>
    </div>
  );
}
// 
export default App;



